import React from 'react';
import { Form } from 'react-bootstrap';
import ConfirmationModal from './ConfirmationModal'; // Adjust path if needed

const PhotoMetadataModal = ({
  show,
  handleClose,
  handleConfirm,
  selectedPhotoIndex,
  getCurrentPhotos,
  handleReplacePhoto,
  editedMetadata,
  handleMetadataChange,
}) => {
  const currentPhoto = selectedPhotoIndex !== null ? getCurrentPhotos()[selectedPhotoIndex] : null;

  return (
    <ConfirmationModal
      show={show}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      title={
        selectedPhotoIndex !== null
          ? `Localisation_Vue_${selectedPhotoIndex + 1}`
          : "Modifier les métadonnées"
      }
      buttonTitle="Sauvegarder"
      LinkTitle="Annuler"
    >
      {selectedPhotoIndex !== null && currentPhoto && (
        <>
          {/* Image Preview and Replace Button */}
          <div
            className="mb-3 position-relative"
            style={{
              maxWidth: "100%",
              maxHeight: "200px",
              overflow: "hidden",
            }}
          >
            <img
              src={currentPhoto.url || "/placeholder.png"}
              alt={`Preview ${selectedPhotoIndex + 1}`}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
              }}
            />
            <Form.Group
              controlId="photoReplace"
              className="position-absolute top-50 start-50 translate-middle text-center"
            >
              <Form.Label
                className="photoReplaceText p-2 rounded d-flex flex-column align-items-center justify-content-center"
                htmlFor="photoReplaceInput"
                style={{
                  cursor: "pointer",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  color: "white",
                }}
              >
                <img
                  src="/pen.png"
                  alt="Edit pic"
                  style={{ width: "24px", height: "24px" }}
                ></img>
                <span className="mt-1" style={{ background: "transparent" }}>
                  Modifier la photo
                </span>
              </Form.Label>
              <Form.Control
                id="photoReplaceInput"
                type="file"
                accept="image/*"
                onChange={(e) => handleReplacePhoto(e, selectedPhotoIndex)}
                style={{
                  opacity: 0,
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  top: 0,
                  left: 0,
                  cursor: "pointer",
                }}
              />
            </Form.Group>
          </div>

          {/* Metadata Fields */}
          {/* <Form.Group controlId="photoName" className="mb-3">
            <Form.Label>Nom de la vue</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={editedMetadata.name}
              onChange={handleMetadataChange}
              placeholder="Ex: Vue Entrée Principale"
            />
          </Form.Group> */}

          <Form.Group controlId="photoLocation">
            <Form.Label>Coordonnées GPS</Form.Label>
            <Form.Control
              type="text"
              name="location"
              value={editedMetadata.location}
              onChange={handleMetadataChange}
              placeholder="XX.XXXX° N/S, XX.XXXX° E/W"
            />
            <Form.Text className="text-muted d-flex align-items-start gap-2 mt-2">
              <img
                src="/Info-circle.png"
                alt="Hint"
                style={{ width: "20px",  marginTop: "0px" }}
              ></img>
              <span className="text-muted-custom">
                Rentrez l'adresse du bâtiment sur Google Maps, marquez
                l'emplacement exact sur la carte et notez les coordonnées GPS
                précises de la caméra.
              </span>
            </Form.Text>
          </Form.Group>
        </>
      )}
    </ConfirmationModal>
  );
};

export default PhotoMetadataModal;